/**
 * `src/creature` public surface. Owner: Creature (P1 DNA/parts/rig/mesh/look + «Облик»; P2 animation runtime, clips,
 * choreography). Architecture §3.6 lists the pure API this file exports; other features never import this runtime:
 * they use `ctx.services.creatures` (architecture §1.1). The engine may import types only.
 *
 * P1 exports: the DNA codec (`dnaCodec`, `ghostDNA`, `appearanceFromRng`, `resolveSpec`…), `buildRig`, `buildCreature` /
 * `buildCreatureMesh`, `lookFromAppearance`, `faceToBones`, `poseToPalette`, the Kunstkamera fixtures and
 * `createCreatureService` (CreatureService.active/get + AnimService.prepare).
 */
import type { FeatureModule } from '../shared';
import { creatureDebugApi } from './debug';
import { creatureSlice } from './save';
import { creatureScreens } from './screens';
import { createCreatureService } from './service';

export const creature: FeatureModule = {
  key: 'creature',
  slices: [creatureSlice],
  screens: creatureScreens,
  onBoot(ctx) {
    // Register CreatureService (P1: active/get + prepare; P2 completes `anim`).
    (ctx.services as { creatures: unknown }).creatures = createCreatureService(ctx.store);
  },
  debugApi: () => ({ creature: creatureDebugApi(), anim: {} }),
};

export { creatureSlice, type CreatureSave } from './save';
export * from './dna';
export * from './rig';
export { poseToPalette, postureLayer, addPose, previewIdle, type SparsePose } from './rig/pose';
export { landmarks, type LandmarkPoint } from './rig/landmarks';
export * from './mesh';
export * from './look';
export { createCreatureService, prepareCreature } from './service';

export * from './atelier-api';
